import React from 'react'
import { getClient } from '../client'
import { groqSanityPageQuery, propsSanity } from '../lib/libFunctions'
import StandardContentPage from '../components/standard-content-page/standard-content-page.component'

export default function SbcaPage({ page }) {
  return (
    <StandardContentPage
      page={page}
      heroCtaHref="https://www.sbca-lombok.com/"
      heroCtaLabel="Visit the SBCA website"
      heroCtaExternal
    />
  )
}

export async function getServerSideProps() {
  const data = await getClient().fetch(groqSanityPageQuery('sbca'), {})

  if (!data?.length) return { notFound: true }

  return {
    props: {
      page: propsSanity(data),
    },
  }
}
